module.exports = __webpack_public_path__ + "static/img/om.2b1990c2.svg";